export const stringsKey = "AskQuestionWidget";
export const englishStrings = {
	widgetLabel: "Label Name",
	variableName: "Variable Name",
	timeOut: "Timeout",
	questionText: "Question Text",
	questionAudioFile: "Question Audio file",
	retryMessage: "Retry Message",
	retryAudioFile: "Retry Audio File",
	maxRetries: "Max Retries",
	labelErrorMessage: "The label field is required.",
	variableNameErrorMessage: "The variable name field is required.",
	timeoutErrorMessage: "The timeout field is required.",
};
